import prepare from '../base/prepare';
import rootReducer from '../base/reducer';

export default (initialState, history) => prepare({initialState, rootReducer, history, name: 'Questionnaires'});



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/store.js